/* eslint-disable no-console */
import geodesic  from 'geographiclib-geodesic';

/**
 *  Calcula área de um polígono em metros quadrados
 */
export const measureArea = (coordinates, invertLatLng = false) => {
  let geod = geodesic.Geodesic.WGS84;
  let geodPolygonArea = geod.Polygon(false);
  let latArrPos = 0;
  let lngArrPos = 1;

  if(invertLatLng) {
    latArrPos = 1;
    lngArrPos = 0;
  }    

  let coordinatesFlat = coordinates.flat(Infinity);

  for (let c = 0; c < coordinatesFlat.length; c = c+2) {
    geodPolygonArea.AddPoint(coordinatesFlat[c+latArrPos], coordinatesFlat[c+lngArrPos]);
  }
  
  return Math.abs(geodPolygonArea.Compute(false, true).area.toFixed(3)); 
};

/**
 *  Calcula comprimento de uma linha em metros
 */
export const measureLength = (coordinates, invertLatLng = false) => {
  let geod = geodesic.Geodesic.WGS84;
  let lenght = 0;
  let latArrPos = 0;
  let lngArrPos = 1;

  if(invertLatLng) {
    latArrPos = 1;
    lngArrPos = 0;
  }

  for (let c = 0; c < coordinates.length - 1; ++c) {   
    lenght += geod.Inverse(
        coordinates[c][latArrPos], coordinates[c][lngArrPos], 
        coordinates[c+1][latArrPos], coordinates[c+1][lngArrPos]
      ).s12;    
  }

  return Math.abs(lenght.toFixed(3));   
};